export default __webpack_public_path__ + "static/media/Head_1_Ear_2_C2.b92a98c6.svg";